import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.now";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import { __awaiter, __generator, __read, __spread } from "tslib";
import router from '@/router';
import { getQS, is, registerShare, disableShare, enableShare, isUndef, replace, isArray, serverDateNow, dateParse, dateOffset, dateNow, dateFormat, isPopupDisplay, loadImage, loadScript } from '@/lib/utils'; // import jssdk from '@forzoom/jssdk';

import jssdk from '@/lib/script/jssdk';
import { ROUTE_NAME, KEY_GENE_POPUP, datePopup, STATIC_HOST, loginFn, KEY_LOGIN_NEXT } from '@/lib/constant';
import { decodeJwtPayload } from '@/lib/script/crypto';
import { set, get, del } from '@/lib/service/storage';
import url from 'url';
import querystring from 'querystring';
import { setTitle as setWechatTitle } from '@/lib/utils';
import { isFunction } from '@/lib/utils';
import * as Sentry from '@sentry/browser';
import { CommonPopup } from '@/components/popup/commonPopup';
import { CountdownPopup } from '@/components/popup/countdownPopup';
import { GenePopup2 } from '@/features/gene/genePopup2';
import { MarketPopup } from '@/components/popup/marketPopup';
import { ChangePackagePopup } from '@/components/popup/changePackagePopup';
import queue from '@/lib/queue';
import { FirstDayPopup } from '@/components/popup/firstDayPopup';
import store from '@/store';
var recordReferrerStat = {
  /** 是否正在请求 */
  req: false,

  /** 是否请求完成 */
  done: false
};
var joinTeamHintVisible = true;
/**
 * 登录hook
 */

export function login(to, from, next) {
  var _a;

  return __awaiter(this, void 0, void 0, function () {
    var auth, needBinding, needLogin, qs, jwt, parsedJwt, isWeixin, redirectUrlComponent, redirectUrl, loginRdata, qs_1, nqs, host, arr, redirectUrl, hash, url_1, basicInfo, nextPath, qs_2, state, activityIds;

    var _this = this;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          auth = to.meta.auth;
          needBinding = to.meta.needBinding;
          needLogin = to.meta.needLogin;

          if (auth === false) {
            next();
            return [2
            /*return*/
            ];
          }

          qs = getQS();
          jwt = qs.jwt;

          if (!jwt) {
            jwt = store.state.auth.jwt;
          } // 从storage获取jwt


          if (!jwt) {
            jwt = get('jwt');
          }

          parsedJwt = null;

          if (jwt) {
            parsedJwt = decodeJwtPayload(jwt);
          } // 解析成功 并且 没有过期


          if (parsedJwt && Date.now() < parsedJwt.exp * 1000) {
            store.commit('auth/setJwt', jwt);
          }

          isWeixin = is.weixin();
          if (!isWeixin) return [3
          /*break*/
          , 5];
          if (!(typeof qs.code === 'string' && qs.code.length > 0)) return [3
          /*break*/
          , 3];
          store.commit('startRequest'); // 存在跳转

          if (qs.redirect && qs.redirect.length > 0) {
            redirectUrlComponent = url.parse(qs.redirect, true); // console.log('target 回调数据1', redirectUrlComponent);
            // @ts-ignore

            redirectUrlComponent.search = null; // 写入code和state

            if (redirectUrlComponent.query) {
              redirectUrlComponent.query.code = qs.code;
              redirectUrlComponent.query.state = qs.state;
            } else {
              redirectUrlComponent.query = {
                code: qs.code,
                state: qs.state
              };
            }

            redirectUrl = url.format(redirectUrlComponent); // console.log('target 回调数据3', redirectUrl);

            location.replace(redirectUrl);
            return [2
            /*return*/
            ];
          }

          if (!(qs.state && qs.state.indexOf('wechat') > -1)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , store.dispatch('auth/login', qs)];

        case 1:
          loginRdata = _b.sent();

          if (loginRdata.status === 1) {
            qs_1 = getQS(loginRdata.redirectUrl);
            nqs = getQS();

            if (qs_1.redirect_uri) {
              qs_1.redirect_uri = encodeURIComponent(qs_1.redirect_uri + '') + encodeURIComponent(nqs.referrer ? "referrer=" + nqs.referrer : '') + encodeURIComponent(location.hash === '#/' ? '' : location.hash);
            }

            host = loginRdata.redirectUrl.split('?')[0];
            arr = Object.keys(qs_1).map(function (key) {
              return key + "=" + qs_1[key];
            });
            redirectUrl = host + "?" + arr.join('&'); // console.log('target 登录接口数据 1-2', host, arr);

            location.replace(redirectUrl);
            return [2
            /*return*/
            ];
          }

          if (loginRdata.status === 10000) {
            store.commit('endRequest');
            return [2
            /*return*/
            , next({
              name: ROUTE_NAME.USER_PHONE_LOGIN
            })];
          }

          if (loginRdata.status === 3) {
            // 当前有一个请求，所以这次请求结果要求停止导航
            return [2
            /*return*/
            ];
          }

          delete qs.code;
          delete qs.state;
          hash = decodeURIComponent((_a = qs.hash) !== null && _a !== void 0 ? _a : '');
          delete qs.hash; // console.log('target 回调数据6', qs, location, hash);

          location.replace(location.protocol + "//" + location.host + location.pathname + "?" + querystring.stringify(qs) + hash + location.hash);
          return [2
          /*return*/
          ];

        case 2:
          if (qs.state && (qs.state.indexOf('joyrun') > -1 || qs.state.indexOf('jianbu') > -1 || qs.state.indexOf('gudong') > -1) && to.fullPath === '/' && !qs.hash) {
            url_1 = location.protocol + "//" + location.host + location.pathname + "?" + querystring.stringify(qs) + location.hash + (qs.state.indexOf('thirdplat') > -1 ? 'user/third_plat' : 'sign_in_enter'); // console.log('target 回调数据5', url, qs, location);
            // @ts-ignore

            if (window && window.history && window.history.replaceState) {
              window.history.replaceState(null, window.document.title, url_1);
            } else {
              location.replace(url_1);
            }

            location.reload();
            return [2
            /*return*/
            ];
          }

          _b.label = 3;

        case 3:
          return [4
          /*yield*/
          , store.dispatch('user/getBasicInfo')];

        case 4:
          _b.sent();

          basicInfo = store.state.user.basicInfo;

          if (basicInfo && basicInfo.id === -1 && (needBinding || needLogin)) {
            _Dialog.confirm({
              title: '授权登录提示',
              message: '你当前处于游客模式，即将进入用户相关页面，需要您登录后方可进入。',
              confirmButtonText: '立即登录'
            }).then(function () {
              return __awaiter(_this, void 0, void 0, function () {
                var rdata, status, name;

                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      if ((_a = to.meta) === null || _a === void 0 ? void 0 : _a.needLoginNext) {
                        set(KEY_LOGIN_NEXT, to.path);
                      }

                      return [4
                      /*yield*/
                      , loginFn()];

                    case 1:
                      rdata = _b.sent();
                      status = rdata === null || rdata === void 0 ? void 0 : rdata.status;
                      name = rdata === null || rdata === void 0 ? void 0 : rdata.name;

                      if (status === 0) {
                        name ? location.replace(name) : next();
                      } else if (status === 1) {
                        location.replace(name);
                      } else if (status === 10000) {
                        next({
                          name: name
                        });
                      }

                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            })["catch"](function () {
              next(false);
            });
          } else {
            nextPath = get(KEY_LOGIN_NEXT);

            if (nextPath) {
              del(KEY_LOGIN_NEXT);
              nextPath === to.path ? next() : next({
                path: nextPath
              });
            } else {
              next();
            }
          }

          return [3
          /*break*/
          , 9];

        case 5:
          qs_2 = getQS();
          if (!(qs_2.env === 'inner')) return [3
          /*break*/
          , 9];
          if (!!store.state.auth.jwt) return [3
          /*break*/
          , 6];
          next({
            name: ROUTE_NAME.USER_PHONE_LOGIN
          });
          return [3
          /*break*/
          , 9];

        case 6:
          state = store.state.user;
          if (!!state.basicInfo) return [3
          /*break*/
          , 8];
          activityIds = store.getters['activity/activityIds'];
          store.dispatch('getProvinceList');
          return [4
          /*yield*/
          , Promise.all(__spread([store.dispatch('user/getBasicInfo')], activityIds.map(function (activityId) {
            return store.dispatch('activity/getBasicInfo', {
              activityId: activityId,
              formPath: 'h5登录'
            });
          })))];

        case 7:
          _b.sent();

          _b.label = 8;

        case 8:
          next();
          _b.label = 9;

        case 9:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 检查是否引导手机号绑定
 */

export function mobileBind(to, from, next) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, function () {
    var store, basicInfo;
    return __generator(this, function (_c) {
      store = this.app.$store;
      basicInfo = (_b = (_a = store === null || store === void 0 ? void 0 : store.state) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.basicInfo;

      if (basicInfo && !basicInfo.mobile_bound && to.meta && to.meta.needBinding) {
        next({
          name: ROUTE_NAME.USER_PHONE_BINDING,
          params: {
            routeTo: to.fullPath
          }
        });
      } else {
        next();
      }

      return [2
      /*return*/
      ];
    });
  });
}
/**
 * 完成jssdk的config
 */

export function jssdkConfig(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var store, meta;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          store = this.app.$store;
          meta = to.meta;

          if (meta && meta.auth === false || !is.weixin()) {
            return [2
            /*return*/
            , next()];
          } // 保存资源存在


          return [4
          /*yield*/
          , loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')];

        case 1:
          // 保存资源存在
          _a.sent(); // 获取JS-SDK


          store.dispatch('getJSSDKParams', {
            url: encodeURIComponent(location.href.substr(0, location.href.indexOf(location.hash)))
          }).then(function (params) {
            if (!params) {
              return;
            }

            jssdk.config({
              appId: params.appId,
              timestamp: params.timestamp,
              nonceStr: params.nonceStr,
              signature: params.signature,
              jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'closeWindow', 'hideOptionMenu', 'chooseWXPay', 'getLocation', 'getLocalImgData', 'hideMenuItems', 'showMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
              openTagList: ['wx-open-launch-weapp'],
              debug: false
            }); // @ts-ignore

            jssdk.error(function (res) {
              // tip: config:fail没有意义
              if (res.errMsg !== 'config:fail') {
                Sentry.captureMessage(res.errMsg);
              }

              _Dialog({
                title: '错误',
                message: "\u90E8\u5206\u914D\u7F6E\u4FE1\u606F\u5931\u6548(" + res.errMsg + ")\uFF0C\u53EF\u80FD\u5BFC\u81F4\u90E8\u5206\u529F\u80FD\u4E0D\u53EF\u7528",
                confirmButtonText: '刷新',
                cancelButtonText: '继续',
                showCancelButton: true
              }).then(function (action) {
                if (action === 'confirm') {
                  location.reload();
                }
              });
            });
          });
          next();
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 设置title
 */

export function setCommonTitle(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var disableShare, basicInfo, qs, activityId, info, link, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          disableShare = to.meta && to.meta.disableShare ? true : false;
          console.log('target settitle router', to.meta); // 没有登录信息

          if (to.meta && to.meta.shareWord === false) {
            next();
            return [2
            /*return*/
            ];
          }

          basicInfo = store.state.user.basicInfo;

          if ((basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.id) === 359197) {// new VConsole()
          }

          qs = getQS();
          activityId = to.params.activityId || to.query.activityId || qs.activity_id || store.getters['activity/activityId'];

          if (basicInfo) {
            qs.referrer = String(basicInfo.id);
          }

          info = store.state.activity.basicInfo[activityId];
          if (!(activityId && isUndef(info))) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , store.dispatch('activity/getBasicInfo', {
            activityId: activityId,
            forceUpdate: true,
            formPath: 'setCommonTitle'
          })];

        case 1:
          _a.sent();

          info = store.state.activity.basicInfo[activityId];
          _a.label = 2;

        case 2:
          console.log('target 分享设置', info === null || info === void 0 ? void 0 : info.id, activityId);
          link = "" + location.origin + location.pathname + "?" + querystring.stringify(qs) + "#" + to.fullPath;

          if (!isUndef(info)) {
            data = {
              join_index: '' + info.join_index,
              user_name: basicInfo.nickname,
              team_name: info.team_name
            }; // console.log(info!.joined ? replace(info!.share_text_joined, data) as string : replace(info!.share_text_not_joined, data) as string,'看看标题');
            //
            //

            qs.team_id = String(info.team_id || '');
            console.log('target 设置分享数据', link);
            registerShare({
              title: info.joined ? replace(info.share_title_joined, data) : replace(info.share_title_not_joined, data),
              desc: info.joined ? replace(info.share_text_joined, data) : replace(info.share_text_not_joined, data),
              // link:`${window.pageUrl}${window.appPageRoot}?${querystring.stringify(qs)}#${to.path}`,
              // link: window.location.href,
              link: link,
              imgUrl: info.share_logo
            }, disableShare);
          } else {
            registerShare({
              title: '百日跑',
              desc: '看到坚持的力量',
              // link: window.location.href,
              link: link,
              //  link: `${window.pageUrl}${window.appPageRoot}?${querystring.stringify(qs)}#${to.path}`,
              imgUrl: ''
            }, disableShare);
          }

          next();
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 上报邀请者
 */

export function recordReferrer(to) {
  return __awaiter(this, void 0, void 0, function () {
    var store, referrer, rdata;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          store = this.app.$store; // 没有登录时，不发送请求

          if (!store.state.auth.jwt) {
            return [2
            /*return*/
            ];
          }

          referrer = getQS().referrer;

          if (recordReferrerStat.done || recordReferrerStat.req || !referrer) {
            return [2
            /*return*/
            ];
          }

          if (isNaN(Number(referrer))) {
            // 主动捕获错误或异常
            Sentry.captureException(new Error('invalid referrer'));
            return [2
            /*return*/
            ];
          }

          recordReferrerStat.req = true;
          return [4
          /*yield*/
          , store.dispatch('user/recordReferrer', referrer)];

        case 1:
          rdata = _a.sent();

          if (rdata.status === 0) {
            recordReferrerStat.done = true;
          }

          recordReferrerStat.req = false;
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 禁止分享
 */

export function disableShareHook(to, from, next) {
  if (to.meta && to.meta.disableShare) {
    disableShare();
  }

  next();
}
/**
 * 允许分享
 */

export function enableShareHook(route) {
  if (route.meta && route.meta.disableShare) {
    enableShare();
  }
}
export function setTitle(to) {
  if (to.meta && to.meta.title) {
    var title = isFunction(to.meta.title) ? to.meta.title(to) : to.meta.title;
    setWechatTitle(title);
  } else {
    setWechatTitle('百日跑');
  }
}
/**
 * 设置页pv
 * @param to
 */

export function recordPV(to) {
  if (aplus_queue) {
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [{
        is_auto: false
      }, {
        page_name: to.name
      }]
    });
  }
}
/**
 * 设置页面变量
 */

export function setReportData(to) {
  if (aplus_queue) {
    var srctag = getQS().srctag;
    var pagefrom = getQS().from;

    if (srctag) {
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['srctag', 'CLK', {
          srctag: srctag
        }]
      }); // gio('page.set', { srctag });
    }

    if (pagefrom) {
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['pagefrom', 'CLK', {
          pagefrom: pagefrom
        }]
      }); // gio('page.set', { pagefrom });
    }
  }
}
export function blockPlatform(to, from, next) {
  if (!to.meta || getQS().env === 'gio') {
    next();
    return;
  }

  var platforms = to.meta.blockPlatform;

  if (!platforms) {
    next();
    return;
  }

  if (!isArray(platforms)) {
    next();
    return;
  } // if (platforms.indexOf(getPlatform()) >= 0) {
  //     next(false);
  //     return;
  // }


  next();
}
/**
 * 检查开跑第一天
 */

export function checkFirstDayPopup(to) {
  var _this = this; // @ts-ignore


  var store = this.app.$store;

  function isInFirstDay() {
    var state = store.state.activity;
    var activityId = store.getters['activity/activityId'];

    if (isUndef(state.basicInfo[activityId])) {
      return false;
    }

    var now = dateNow().valueOf();
    var signInStartDate = dateParse(state.basicInfo[activityId].sign_in_start_date);
    return now >= signInStartDate.valueOf() && now < dateOffset(signInStartDate, 1).valueOf();
  }

  queue.promise(function (resolve, reject) {
    return __awaiter(_this, void 0, void 0, function () {
      var activityId, key, hasPopup, prefix, popup;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            activityId = store.getters['activity/activityId'];
            key = "hundred_" + activityId + "_start_popup";
            hasPopup = get(key);

            if (!isInFirstDay() || hasPopup || Number(activityId) !== 3) {
              resolve();
              return [2
              /*return*/
              ];
            }

            prefix = STATIC_HOST + '/meta/activity_3/popup/first_day/';
            return [4
            /*yield*/
            , Promise.all([loadImage(prefix + "ticket_slot.png"), loadImage(prefix + "ticket_content.png"), loadImage(prefix + "ticket_content_shadow.png")])];

          case 1:
            _a.sent(); // @ts-ignore


            popup = new FirstDayPopup({
              el: document.createElement('div')
            });
            document.body.appendChild(popup.$el);
            popup.value = true;
            set(key, '1');

            popup.onClose = function () {
              resolve();
            };

            return [2
            /*return*/
            ];
        }
      });
    });
  });
}
/**
 * 检查其他的popup
 */

export function checkMarketPopup(to) {
  queue.promise(function (resolve, reject) {
    var route = router.currentRoute;

    if (!isPopupDisplay(route, 'market')) {
      resolve();
      return;
    }

    var hasPopup = get('market_20190720_popup');
    var now = dateNow();

    if (!hasPopup && now.valueOf() >= dateParse('2019-07-20 00:00:00').valueOf() && now.valueOf() <= dateParse('2019-07-20 24:00:00').valueOf()) {
      var popup = void 0; // @ts-ignore

      popup = new MarketPopup({
        el: document.createElement('div')
      });
      document.body.appendChild(popup.$el);
      popup.value = true;
      set('market_20190720_popup', '1');

      popup.onClose = function () {
        resolve();
      };
    } else {
      resolve();
    }
  });
}
/** 检查是否需要显示引导加入战队弹窗 */

export function checkJoinTeamHint(to, from) {
  return __awaiter(this, void 0, void 0, function () {
    var store;
    return __generator(this, function (_a) {
      store = this.app.$store;
      queue.promise(function (resolve, reject) {
        var route = router.currentRoute;
        var name = route.name;

        if (name !== ROUTE_NAME.ACTIVITY && name !== ROUTE_NAME.SIGN_IN_ENTER && name !== ROUTE_NAME.COMMUNITY && name !== ROUTE_NAME.USER_HOME) {
          resolve();
          return;
        } // todo: 这里从默认写死改成使用getter


        var activityId = store.getters['activity/activityId'];
        var basicInfo = store.state.activity.basicInfo[activityId];

        if (basicInfo && basicInfo.joined && joinTeamHintVisible && basicInfo.startParticipation && !basicInfo.closeParticipation) {
          if (!basicInfo.team_id) {
            // 没有选择战队
            store.commit('setPopupContent', {
              src: 'https://static.run100.runorout.cn/meta/team/join_hint_2.png',
              desc2: '当前您还未选择战队<br>请您加入战队，和小伙伴们一起奔跑吧',
              actionText: '加入战队',
              actionCb: function actionCb() {
                router.push({
                  name: ROUTE_NAME.ACTIVITY_SELECT_TEAM,
                  params: {
                    // todo: 目前只能默认是2
                    activityId: activityId
                  },
                  query: {
                    step: '1'
                  }
                });
                store.commit('setPopupVisible', false);
                resolve();
              }
            });
            store.commit('setPopupVisible', true);
          }

          joinTeamHintVisible = false;
        } else {
          resolve();
        }
      });
      return [2
      /*return*/
      ];
    });
  });
}
/** 倒计时弹窗 */

export function checkCountdownPopup(to, from) {
  queue.promise(function (resolve, reject) {
    var route = router.currentRoute;

    if (!isPopupDisplay(route, 'countdown')) {
      resolve();
      return;
    }

    var now = dateNow();
    var date = dateFormat(now, 'Y-m-d');
    var key = "market_" + date + "_popup";

    if (!get(key) && datePopup[date]) {
      var popup = void 0; // @ts-ignore

      popup = new CountdownPopup({
        el: document.createElement('div')
      });
      document.body.appendChild(popup.$el);
      popup.value = true;
      set(key, '1');

      popup.onClose = function () {
        resolve();
      };
    } else {
      resolve();
    }
  });
}
export function checkNormalJoinPopup(to, from) {
  // @ts-ignore
  var store = this.app.$store;
  queue.promise(function (resolve, reject) {
    var name = router.currentRoute.name;

    if (name !== ROUTE_NAME.ACTIVITY && name !== ROUTE_NAME.SIGN_IN_ENTER) {
      resolve();
      return;
    }

    var activityId = router.currentRoute.params.activityId;
    var basicInfo = store.state.activity.basicInfo[activityId];

    if (basicInfo && !basicInfo.joined && basicInfo.startParticipation && !basicInfo.closeParticipation && store.state.activity.joinHint) {
      var popup_1; // @ts-ignore

      popup_1 = new CommonPopup({
        el: document.createElement('div')
      });
      popup_1.src = 'https://static.run100.runorout.cn/meta/team/join_hint_1.png';
      popup_1.desc2 = '加入百日跑得大礼包<br>和小伙伴们一起奔跑100天<br>看到坚持的力量！';
      popup_1.actionText = '立即加入';

      popup_1.actionCb = function () {
        popup_1.value = false;
        router.push({
          name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
          params: {
            activityId: activityId
          }
        });
      };

      document.body.appendChild(popup_1.$el);
      popup_1.value = true;
      store.commit('activity/setJoinHintVisible', false);

      popup_1.onClose = function () {
        resolve();
      };
    } else {
      resolve();
    }
  });
}
/** 检测是否需要显示基因测试弹窗 */

export function checkShowGenePopup(to, from) {
  return __awaiter(this, void 0, void 0, function () {
    var store, now, isEnd;

    var _this = this;

    return __generator(this, function (_a) {
      store = this.app.$store;
      now = serverDateNow().valueOf();
      isEnd = now > new Date('2019/12/01').valueOf();

      if (isEnd) {
        return [2
        /*return*/
        ];
      }

      queue.promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, function () {
          var route, activityId, basicInfo, packageIds, type, popup2;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                route = router.currentRoute;
                if (!(route.params.activityId === '2' && route.name === ROUTE_NAME.ACTIVITY || route.name === ROUTE_NAME.COMMUNITY || route.name === ROUTE_NAME.USER_HOME)) return [3
                /*break*/
                , 2];
                activityId = '2';
                basicInfo = store.state.activity.basicInfo[activityId];
                return [4
                /*yield*/
                , store.dispatch('activity/getPackage', {
                  activityId: activityId
                })];

              case 1:
                _a.sent();

                packageIds = store.state.activity.activityPackages[activityId] || [];

                if (get(KEY_GENE_POPUP) === 'hide') {
                  resolve();
                  return [2
                  /*return*/
                  ];
                } // 报名日期内 已经报名的 没有买基因的同学显示弹窗


                if (basicInfo.startParticipation && basicInfo.joined && basicInfo.package_id === packageIds[0]) {
                  type = Math.floor(Math.random() * 2);
                  popup2 = void 0; // @ts-ignore

                  popup2 = new GenePopup2({
                    el: document.createElement('div'),
                    props: {
                      type: type
                    }
                  });
                  document.body.appendChild(popup2.$el);

                  switch (type) {
                    case 0:
                      popup2.type = 0;
                      break;

                    case 1:
                    case 2:
                      popup2.type = 1;
                      break;
                  }

                  popup2.value = true; // gio('page.set', { ab_test: type === 0 ? 'gene_popup_type_4' : 'gene_popup_type_5' });

                  popup2.onClose = function () {
                    set(KEY_GENE_POPUP, 'hide');
                    resolve();
                  };
                } else {
                  resolve();
                }

                return [3
                /*break*/
                , 3];

              case 2:
                resolve();
                _a.label = 3;

              case 3:
                return [2
                /*return*/
                ];
            }
          });
        });
      });
      return [2
      /*return*/
      ];
    });
  });
} // 检查是否是队长(不是队长禁止进入队长的某些页面)

export function checkMonitor(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var store, isMonitorTeam;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          store = this.app.$store;
          if (!(to.meta && to.meta.checkMonitor)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , store.dispatch('monitor/getTeamList', {
            activityId: to.params.activityId
          })];

        case 1:
          _a.sent();

          isMonitorTeam = (store.state.monitor.teamListMap[to.params.activityId] || []).length > 0;

          if (!isMonitorTeam) {
            next({
              name: ROUTE_NAME.ACTIVITY,
              params: {
                activityId: to.params.activityId
              },
              replace: true
            });
          } else {
            next();
          }

          return [3
          /*break*/
          , 3];

        case 2:
          next();
          _a.label = 3;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
} // 检查加入弹窗

export function checkJoinPopup(to, from) {//
}
/**
 * 获取activityId数据
 */

export function prepareActivityInfo(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var store, activityId, activitySpecialId;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          store = this.app.$store;
          activityId = to.params.activityId;
          activitySpecialId = to.params.activitySpecialId || to.query.activitySpecialId;

          if (!activityId) {
            next();
            return [2
            /*return*/
            ];
          }

          return [4
          /*yield*/
          , store.dispatch('activity/getBasicInfo', {
            activityId: activityId,
            activitySpecialId: activitySpecialId,
            forceUpdate: to.params.activityForceUpdate || false,
            formPath: 'prepareActivityInfo'
          })];

        case 1:
          _a.sent();

          next();
          return [2
          /*return*/
          ];
      }
    });
  });
}
export function teslaRedirect(to, from, next) {
  var mirrorHost = process.env.RO_MIRROR_HOST;
  var normalHost = process.env.RO_NORMAL_HOST;

  if (!mirrorHost || !normalHost) {
    next();
    return;
  }

  var isTeslaPage = to.path.indexOf('/tesla/index') >= 0 || to.path.indexOf('/tesla/list') >= 0;
  var qs = getQS();
  var jwt = store.state.auth.jwt;

  if (jwt) {
    qs.jwt = jwt;
  }

  if (isTeslaPage && location.host !== mirrorHost) {
    // location.host = mirrorHost;
    location.href = location.protocol + "//" + mirrorHost + location.pathname + "?" + querystring.stringify(qs) + "#" + to.fullPath;
  } else if (!isTeslaPage && location.host !== normalHost) {
    // location.host = normalHost;
    location.href = location.protocol + "//" + normalHost + location.pathname + "?" + querystring.stringify(qs) + "#" + to.fullPath;
  } else {
    next();
  }
}
/**
 * 检查修改套餐弹窗
 */

export function checkChangePackagePopup(to) {
  var basicInfo = store.state.activity.basicInfo[24];
  var hasShow = get('CHANGE_PACKAGE_HAS_SHOW');
  var joinTime = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.join_time;
  var outOfTimeRange = true; // console.log('target1234', joinTime, hasShow);

  if (joinTime) {
    var range = dateNow().valueOf() - dateParse(joinTime).valueOf();

    if (range > 2 * 60 * 60 * 1000 && range < 24 * 60 * 60 * 1000) {
      outOfTimeRange = false;
    }
  } // console.log('target567', outOfTimeRange, basicInfo);


  if ((basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.joined) && String(basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.package_id) !== '79' && !hasShow && !outOfTimeRange) {
    queue.promise(function (resolve, reject) {
      var popup; // @ts-ignore

      popup = new ChangePackagePopup({
        el: document.createElement('div')
      });
      document.body.appendChild(popup.$el);
      popup.value = true;
      set('CHANGE_PACKAGE_HAS_SHOW', 'true');

      popup.onClose = function () {
        resolve();
      };
    });
  }
}